enum ActionType {
    REQUEST_LOCATION_TAGS_SUMMARY = '[DASHBOARD/LOCATION_TAGS_SUMMARY] GET LOCATION TAGS SUMMARY',
    RECEIVE_LOCATION_TAGS_SUMMARY = '[DASHBOARD/LOCATION_TAGS_SUMMARY] SET LOCATION TAGS SUMMARY',
    LOCATION_TAGS_SUMMARY_REQUEST_FAILED = '[DASHBOARD/LOCATION_TAGS_SUMMARY] LOCATION TAGS SUMMARY REQUEST FAILED',
}

export default ActionType
